import {ScopeValues} from '@dms/api/shared';

export const evaluateSpecificBranch = (
  scopes: string[],
  evaluatorParams: ScopeValues | undefined
) => {
  if (evaluatorParams && 'branchId' in evaluatorParams) {
    return scopes.includes(evaluatorParams.branchId ?? '');
  }

  return false;
};
